import axiosInstance from '../api.service.js';
import constants from '../../constants/constants';

const ENDPOINTORIGIN = "UserCredential/";

const getUserCredentialById = async (id) => await axiosInstance.get(ENDPOINTORIGIN + 'GetUserCredentialById?id=' + id, constants.REQUIRE_INTERCEPTORS);

const getUserCredentialByUserId = async (userId, showArchived) => await axiosInstance.get(ENDPOINTORIGIN + 'GetUserCredentialByUserId?userId=' + userId + "&showArchived=" + showArchived, constants.REQUIRE_INTERCEPTORS);

const getUserCredentials = async (showArchived) => await axiosInstance.get(ENDPOINTORIGIN + 'GetUserCredentials?showArchived=' + showArchived, constants.REQUIRE_INTERCEPTORS);

const saveUserCredential = async (model) => await axiosInstance.post(ENDPOINTORIGIN + 'SaveUserCredential', model, { ...constants.REQUIRE_INTERCEPTORS, fileHandler: true });

const toggleUserCredentialArchive = async (id) => await axiosInstance.get(ENDPOINTORIGIN + 'ToggleUserCredentialArchived?id=' + id, constants.REQUIRE_INTERCEPTORS);

const searchEmployeeByCredential = async (credentialIds) => await axiosInstance.get(ENDPOINTORIGIN + `SearchEmployeeByCredential?credentialIds=${credentialIds}`, constants.REQUIRE_INTERCEPTORS);

const getAttachments = async (userCredentialId) => await axiosInstance.get(ENDPOINTORIGIN + 'GetAttachments?userCredentialId=' + userCredentialId, constants.REQUIRE_INTERCEPTORS);

const renameAttachment = async (attachmentId, name) => await axiosInstance.post(ENDPOINTORIGIN + `RenameAttachment?attachmentId=${attachmentId}&name=${name}`, {}, constants.REQUIRE_INTERCEPTORS);

const deleteAttachment = async (attachmentId) => await axiosInstance.get(ENDPOINTORIGIN + `DeleteAttachment?attachmentId=${attachmentId}`, constants.REQUIRE_INTERCEPTORS);

const saveAttachment = async (model) => await axiosInstance.post(ENDPOINTORIGIN + 'SaveAttachments', model, { ...constants.REQUIRE_INTERCEPTORS, fileHandler: true });

const checkDuplicate = async (userId, credentialId, userCredentialId) => await axiosInstance.get(ENDPOINTORIGIN + `CheckDuplicateUserCredential?userId=${userId}&credentialId=${credentialId}&userCredentialId=${userCredentialId}`, constants.REQUIRE_INTERCEPTORS);

export {
    getUserCredentialById,
    getUserCredentials,
    saveUserCredential,
    getUserCredentialByUserId,
    toggleUserCredentialArchive,
    searchEmployeeByCredential,
    getAttachments,
    renameAttachment,
    deleteAttachment,
    saveAttachment,
    checkDuplicate
}